import {Select, type SelectProps} from '@mantine/core'
import {IconChevronDown} from '@tabler/icons-react'
import type {ReactNode} from 'react'

import classes from './header-select.module.css'

export type HeaderSelectOption<T extends string> = {
    value: T
    label: string
}

type HeaderSelectProps<T extends string> = {
    'aria-label': string
    value: T
    onChange: (value: T) => void
    options: readonly HeaderSelectOption<T>[]
    leftSection?: ReactNode
    width?: number | string
    renderOption?: SelectProps['renderOption']
}

/** Compact header dropdown styled like the dispatch header's default actions. */
export function HeaderSelect<T extends string>({
    'aria-label': ariaLabel,
    value,
    onChange,
    options,
    leftSection,
    width = 128,
    renderOption,
}: HeaderSelectProps<T>) {
    return (
        <Select
            aria-label={ariaLabel}
            value={value}
            onChange={(next) => next && onChange(next as T)}
            data={[...options]}
            allowDeselect={false}
            variant="default"
            size="sm"
            leftSection={leftSection}
            rightSection={<IconChevronDown size={16} stroke={1.5} />}
            rightSectionPointerEvents="none"
            w={width}
            classNames={{input: classes.input}}
            comboboxProps={{withinPortal: true}}
            renderOption={renderOption}
        />
    )
}
